
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["line-demo-common","line-demo-markdown","line-demo-category"],
  getter: () => import(/* webpackChunkName: "meta__Line__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.en.md?type=demo')
};